import { Text, VStack, Box } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'

import FormComponent from '@/features/otherServices/components/ContactForm'

interface Props {
  onSuccess?: () => void
}

function ContactForm({ onSuccess }: Props): React.ReactElement {
  const { t } = useTranslation('otherServices')

  return (
    <Box
      as="section"
      id="contact"
      sx={{
        w: 'full',
      }}
    >
      <VStack
        spacing={{
          base: 4,
          md: 8,
        }}
        layerStyle="container"
        sx={{
          alignItems: 'stretch',
          borderTop: '1px solid',
          borderColor: 'inherit',
        }}
      >
        <VStack
          spacing="1"
          layerStyle="landingSectionHeading"
          sx={{
            alignItems: 'center',
          }}
        >
          <Text as="h1" textStyle="landingSectionTitle">
            {t('contact.title')}
          </Text>
          <Text as="h2" textStyle="landingSectionSubtitle">
            {t('contact.subtitle')}
          </Text>
        </VStack>
        <FormComponent onSuccess={onSuccess} />
      </VStack>
    </Box>
  )
}

export default ContactForm
